import React, { ReactNode } from "react";

export type IconProps = { theme: string; children?: ReactNode };
export type IconsState = IIcons;

const Icons: IIcons = {
  Success: require("!svg-inline-loader!~assets/icons/success.svg"),
  Checkmark: require("!svg-inline-loader!~assets/icons/success.svg"),
  Fail: require("!svg-inline-loader!~assets/icons/fail.svg"),
  PageLeft: require("!svg-inline-loader!~assets/icons/paging_left.svg"),
  PageRight: require("!svg-inline-loader!~assets/icons/paging_right.svg"),
  Close: require("!svg-inline-loader!~assets/icons/close.svg"),
  CloseLite: require("!svg-inline-loader!~assets/icons/close_lite.svg"),
  Facebook: require("!svg-inline-loader!~assets/icons/facebook.svg"),
  X: require("!svg-inline-loader!~assets/icons/x.svg"),
  WhatsApp: require("!svg-inline-loader!~assets/icons/whatsapp.svg"),
  ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up.svg"),
  ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down.svg"),
  Picker: require("!svg-inline-loader!~assets/icons/picker.svg"),
  Slider: require("!svg-inline-loader!~assets/icons/slider.svg"),
  Warning: require("!svg-inline-loader!~assets/icons/warning.svg"),
  Clock: require("!svg-inline-loader!~assets/icons/clockGeneric.svg"),
  BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark.svg"),
};

const IconsContext = React.createContext(getBrandIcons("default"));

/**
 * Handle Brand Icons
 * @param theme String enum for brands (eg: default, bild, welt, etc.)
 */
export function getBrandIcons(theme: string): IIcons {
  theme = theme ? theme.toLowerCase() : "default";
  switch (theme) {
    case "bild":
    case "bz":
      return Object.assign({}, Icons, {
        Success: require("!svg-inline-loader!~assets/icons/success_bild.svg"),
        Checkmark: require("!svg-inline-loader!~assets/icons/checkmark-bild.svg"),
        BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark-bild.svg"),
        Fail: require("!svg-inline-loader!~assets/icons/fail_bild.svg"),
        ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up_bild.svg"),
        ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down_bild.svg"),
        Slider: require("!svg-inline-loader!~assets/icons/slider_bild.svg"),
        Picker: require("!svg-inline-loader!~assets/icons/picker_bild.svg"),
        PageLeft: require("!svg-inline-loader!~assets/icons/paging_left_bild.svg"),
        PageRight: require("!svg-inline-loader!~assets/icons/paging_right_bild.svg"),
        Clock: require("!svg-inline-loader!~assets/icons/clockBild.svg"),
      });
    case "aubi":
    case "cobi":
    case "spobi":
      return Object.assign({}, Icons, {
        Slider: require("!svg-inline-loader!~assets/icons/slider_cobi.svg"),
        Picker: require("!svg-inline-loader!~assets/icons/picker_cobi.svg"),
      });
    case "bild_fitbook":
    case "bild_stylebook":
    case "bild_techbook":
    case "bild_travelbook":
    case "bild_myhomebook":
      return Object.assign({}, Icons, {
        Slider: require("!svg-inline-loader!~assets/icons/slider_bild_books.svg"),
      });
    case "welt":
      return Object.assign({}, Icons, {
        Success: require("!svg-inline-loader!~assets/icons/success_welt.svg"),
        Checkmark: require("!svg-inline-loader!~assets/icons/success_welt.svg"),
        Fail: require("!svg-inline-loader!~assets/icons/fail_bild.svg"),
        ThumbsUp: require("!svg-inline-loader!~assets/icons/thumbs_up_welt.svg"),
        ThumbsDown: require("!svg-inline-loader!~assets/icons/thumbs_down_welt.svg"),
        Slider: require("!svg-inline-loader!~assets/icons/slider_welt.svg"),
        Picker: require("!svg-inline-loader!~assets/icons/picker_welt.svg"),
        PageLeft: require("!svg-inline-loader!~assets/icons/paging_left_welt.svg"),
        PageRight: require("!svg-inline-loader!~assets/icons/paging_right_welt.svg"),
        Clock: require("!svg-inline-loader!~assets/icons/clockWelt.svg"),
        BubbleCheckmark: require("!svg-inline-loader!~assets/icons/bubble_checkmark-welt.svg"),
      });
    case "musikexpress":
      return Object.assign({}, Icons, {
        Facebook: require("!svg-inline-loader!~assets/icons/facebook_black.svg"),
        X: require("!svg-inline-loader!~assets/icons/x_black.svg"),
        WhatsApp: require("!svg-inline-loader!~assets/icons/whatsapp_black.svg"),
        Picker: require("!svg-inline-loader!~assets/icons/picker_musikexpress.svg"),
        Slider: require("!svg-inline-loader!~assets/icons/slider_musikexpress.svg"),
      });
    case "rollingstone":
      return Object.assign({}, Icons, {
        Picker: require("!svg-inline-loader!~assets/icons/picker_rollingstone.svg"),
        Slider: require("!svg-inline-loader!~assets/icons/slider_rollingstone.svg"),
      });
    case "metalhammer":
      return Object.assign({}, Icons, {
        Picker: require("!svg-inline-loader!~assets/icons/picker_metalhammer.svg"),
        Slider: require("!svg-inline-loader!~assets/icons/slider_metalhammer.svg"),
      });
    default:
      return Icons;
  }
}

export class IconsProvider extends React.Component<IconProps, IconsState> {
  constructor(props: IconProps) {
    super(props);
    this.state = getBrandIcons(props.theme);
  }

  public render(): JSX.Element {
    return (
      <IconsContext.Provider value={{ ...this.state }}>
        {this.props.children}
      </IconsContext.Provider>
    );
  }
}

export const withIcons =
  <P extends {}>(WrappedComponent: React.ComponentClass<P> | React.FC<P>) =>
  (props: P & IIcons) => {
    return (
      <IconsContext.Consumer>
        {(value: any) => <WrappedComponent {...props} icons={value} />}
      </IconsContext.Consumer>
    );
  };

export const IconsConsumer = IconsContext.Consumer;

export default Icons;
